import React, { Component } from "react"
import { inject, observer } from "mobx-react"
import styled from "styled-components"

import Spacer from "~/components/Spacer"
import withTranslations from "~/components/_hocs/withTranslations"
import DropdownMenu from "../DropdownMenu"
import Input from "~/components/Form/LandingInput"
import DOBInput from "./DOBInput"
import InputTitle from "./InputTitle"

const Wrap = styled.div`
  display: flex;
  flex-direction: column;
`

@inject((all) => ({
  validateDisplayMessage: all.store.trafficLookup.validateDisplayMessage,
  changeLicenseIDNumber: all.store.trafficLookup.changeLicenseIDNumber,
  licenseIDNumber: all.store.trafficLookup.licenseID,
}))
@observer
class LicenseDobInput extends Component {
  handleRadio = (input) => {
    if (input === "male") {
      this.props.changeGender("male")
    } else {
      this.props.changeGender("female")
    }
  }

  handleChangeLicenseId = (e) => {
    this.props.changeLicenseIDNumber(e.target.value)
  }

  render() {
    const licenseErrorHandler = this.props.validateDisplayMessage("licenseID")
    const hideDOB = this.props.hideDOB || false
    const labelText = hideDOB ? this.props.translate("labelOnly") : this.props.translate("label")
    return (
      <Wrap>
        <InputTitle>
          {labelText}
          <Spacer direction="width" mobile={11} desktop={11} />
          <DropdownMenu columnNumber="one" />
        </InputTitle>
        <Spacer desktop={16} mobile={4} />
        <Input
          placeholder={this.props.translate("placeholder")}
          onChange={this.handleChangeLicenseId}
          value={this.props.licenseIDNumber}
          error={licenseErrorHandler}
          minLength={3}
          maxLength={20}
        />
        {!hideDOB && (
          <>
            <Spacer mobile={36} desktop={16} />
            <DOBInput />
          </>
        )}
      </Wrap>
    )
  }
}

export default withTranslations(LicenseDobInput, "form.traffic.licenseDOB")
